module.exports = "/images/77806a64bf7ca3682dabf76163d89519.svg";